module.exports = __webpack_public_path__ + "img/logo_new.65a2e9d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logo_new.png
// module id = S24b
// module chunks = 0 1 2 3 4 5 6